import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updatePlanAndRateOverrideRuleStatus } from '../../../api/plan-and-rate-override-rules-api'
import type { PlanAndRateOverrideRuleStatus } from '../enums/plan-and-rate-override-rule.enum'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'
import { PLAN_AND_RATE_OVERRIDE_RULE_QUERY_KEY } from './useGetPlanAndRateOverrideRule'

interface Variables {
  id: string
  status: PlanAndRateOverrideRuleStatus
}

export function useTogglePlanAndRateOverrideRuleStatus() {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, Variables>({
    mutationFn: ({ id, status }) =>
      updatePlanAndRateOverrideRuleStatus(id, { status }),
    onSettled: (_data, _err, variables) => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULE_QUERY_KEY, variables.id],
      })
    },
  })
}
